





















import { Prop, Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class InputScore extends Vue {
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: number
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: number = null

    created() {
        this.onExternalChange()
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    onInternalChange(): void {
        this.$emit('input', this.internalValue)
    }

    changeScore(score: number): void {
        if (this.disabled) {
            return
        }

        this.internalValue = score
    }

    classesForScore(score: number): object {
        return {
            'input-score__choice': true,
            'input-score__choice--selectable': !this.disabled,
            'input-score__choice--selected': this.internalValue === score,
        }
    }

    get componentClass(): object {
        return {
            'input-score': true,
            'input-score--disabled': this.disabled,
        }
    }
}
